import { Suspense, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  deleteItem,
  deleteMultipleItem,
  fetchData,
  handleDragEnd,
  toggleStatus,
} from "../../../utils/apiUtils";
import { DeleteButton, PlusButton } from "../../../helper/ImageFormat";
import Breadcrumb from "../../../helper/Breadcrumb";
import CategoryTable from "./CategoryTable";
import DeleteModel, { confirmBulkDelete } from "../../../Components/DeleteModel";
import PerPageSelect from "../../../Components/PerPageSelect";
import TableSearch from "../../../Components/TableSearch";

const Category = () => {
  const navigator = useNavigate();
  const [loading, setLoading] = useState(true);
  const [categoryData, setCategoryData] = useState([]);
  const [deleteItemId, setDeleteItemId] = useState({});
  const [modalOpen, setModalOpen] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const totalPages = Math.ceil(totalCount / perPage);
  const [search, setSearch] = useState("");
  const [isDeleting, setIsDeleting] = useState(false);
  const [selected, setSelected] = useState([])
  const [nextPosition, setNextPosition] = useState(0);

  const fetchCategoryData = async (page = 1, searchQuery = "") => {
    const requestData = {
      perPage: perPage,
      pageNo: page,
      parent_id: null,
      search: searchQuery,
    };
    await fetchData(
      "category-pagination",
      requestData,
      setCategoryData,
      setTotalCount,
      setCurrentPage,
      setLoading,
      setNextPosition
    );
  };


  useEffect(() => {
    const delay = search ? 500 : 0;

    const handler = setTimeout(() => {
      fetchCategoryData(1, search);
    }, delay);

    return () => clearTimeout(handler);
  }, [search, perPage]);

  const handlePageClick = (page) => {
    if (page >= 1 && page <= totalCount) {
      fetchCategoryData(page);
    }
  };

  const handleDelete = async (data) => {
    setDeleteItemId(data);
    setModalOpen(true);
  };



  const confirmDelete = async () => {
    setIsDeleting(true);
    try {
      const res = await deleteItem("category", deleteItemId?.id, fetchCategoryData,[deleteItemId?.image]);
      setDeleteItemId({});
      setModalOpen(false);
      return res;
    } catch (err) {
      return err;
    } finally {
      setIsDeleting(false);
    }
  };


  const handleEditClick = (item) => {
    navigator("/add-category", {
      state: { id: item?.id },
    });
  };

  const handleOnDragEnd = (result) => {
    handleDragEnd({
      result,
      data: categoryData,
      setData: setCategoryData,
      apiEndpoint: "/category-position",
    });
  };

  const handleStatusToggle = async (item) => {
    const data = await toggleStatus("category-status", item?.id);
    if (Object.keys(data).length > 0) {
      setCategoryData((prevCategory) =>
        prevCategory.map((curr) =>
          curr.id === item.id ? { ...curr, isActive: data?.isActive } : curr
        )
      );
    }
  };

  const HandleshowInHome = async (item) => {
    const data = await toggleStatus("category-home-status", item?.id);
    if (data && typeof data === "object" && Object.keys(data).length > 0) {
      setCategoryData((prevdata) =>
        prevdata.map((curr) =>
          curr.id === item.id ? { ...curr, showInHome: data?.showInHome } : curr
        )
      );
    }
  };

  const Tableheader = [
    "Sort Order",
    "Image",
    "Name",
    "Sub Category",
    "Catalogues",
    "Products",
    "Updated At",
    "Is Home",
    "Is Active",
    "Action",
  ];

  const HandleAddCategory = () => {
    navigator("/add-category",{state:{nextPosition}});
  };

  const handlebulkDelete = async () => {
    await confirmBulkDelete({
      itemType: "Category",
      selectedIds: selected,
      deleteApiCall: (ids) => deleteMultipleItem("category-bulk-delete", ids),
      refreshCallback: fetchCategoryData,
    });

  };

  const breadcrumbdata = [
    { label: "Home", path: "/dashboard" },
    { label: "Category", path: "/category" },
  ];
  return (
    <>
      <div className="content-wrapper">
        <div className="page-header mt-5">
          <h3 className="custom-page-title">Category</h3>
          <Breadcrumb items={breadcrumbdata} />
        </div>

        {/* <Suspense fallback={<p>Loadin</p>}>
          <CategoryCards categories={categoryData} />
        </Suspense> */}
        <div
          className="d-flex justify-content-between mb-1"
          style={{ background: "#fff", padding: "10px" }}
        >
           <PerPageSelect value={perPage} onChange={setPerPage}/>
          <div style={{ display: "flex", gap: "20px" }}>
               <TableSearch value={search} onChange={setSearch} />
            <PlusButton handleAdd={HandleAddCategory} module={"Category"} />
            {selected && selected?.length > 0 && (
              <DeleteButton handleAdd={handlebulkDelete} name={"selected currency"} module={"Category"} />
            )}
          </div>
        </div>

        <div className="row">
          <div className="col-md-12 grid-margin stretch-card">
            <div className="card">
              <div className="card-body">
                <CategoryTable
                  loading={loading}
                  categoryData={categoryData}
                  Tableheader={Tableheader}
                  currentPage={currentPage}
                  perPage={perPage}
                  totalPages={totalPages}
                  totalCount={totalCount}
                  handlePageClick={handlePageClick}
                  handleOnDragEnd={handleOnDragEnd}
                  HandleshowInHome={HandleshowInHome}
                  handleStatusToggle={handleStatusToggle}
                  handleEditClick={handleEditClick}
                  handleDelete={handleDelete}
                  selected={selected}
                  setSelected={setSelected}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      {modalOpen && (
        <Suspense fallback={<div>Loading...</div>}>
          <DeleteModel
            deleteModalOpen={modalOpen}
            setDeleteModalOpen={() => setModalOpen(!modalOpen)}
            onConfirm={confirmDelete}
            itemName="Category"
            isDeleting={isDeleting}
          />
        </Suspense>
      )}
    </>
  );
};

export default Category;
